import React, { useEffect } from "react";
import Table from "./Table";
import { useDispatch } from "react-redux";
import { getContacts } from "store/actions";
const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getContacts());
  }, [dispatch]);

  return (
    <>
      <div className="users-wrap">
        <Table />
      </div>
    </>
  );
};

export default Index;
